import { useEffect, useState } from "react";
import PageContainer from "../components/admin/PageContainer";
import CollapseCard from "../components/admin/CollapseCard";
import Modal from "../components/admin/Modal";
import { useToast } from "../components/toast/ToastProvider";

import SubscriptionForm from "../components/admin/SubscriptionForm";
import SubscriptionList from "../components/admin/SubscriptionList";
import { createSubscriber, deleteSubscriber, fetchAllSubscriber, updateSubscriber } from "../service/SubscriptionService";
import Main from "../components/admin/Main";

const Subscription = () => {
  const [Subscription, setSubscription] = useState([]);
  const [selectedSubscription, setSelectedSubscription] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [viewMode, setViewMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const toast = useToast();
  const loadSubscribers = async () => {
    try {
      setLoading(true);
      const res = await fetchAllSubscriber();

      setSubscription(res);
    } catch (error) {
      toast("Error in fetch Subscription", "ERROR");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadSubscribers();
  }, []);
  const handleSave = async (adData) => {
    try {
      const postData = {
        userId: adData.userId,
        plan: adData.plan,
        amount: adData.amount,
        paymentMode: adData.paymentMode,
        paymentParticulars: adData.paymentParticulars,
        expiryDate: adData.expiryDate,
      };

      if (selectedSubscription) {
        await updateSubscriber(selectedSubscription.id, postData);
        toast("subscription Updated", "SUCCESS");
      } else {
        await createSubscriber(postData);
        toast("subscription Added", "SUCCESS");
      }

      setShowModal(false);
      setSelectedSubscription(null);
      setViewMode(false);
      await loadSubscribers();
    } catch (error) {
      toast("Error saving subscription", "ERROR");
    }
  };

  const handleEdit = (ad) => {
    setSelectedSubscription(ad);
    setViewMode(false);
    setShowModal(true);
  };

  const handleView = (ad) => {
    setSelectedSubscription(ad);
    setViewMode(true);
    setShowModal(true);
  };

  const handleDelete = async (postId) => {
    if (window.confirm("Are you sure you want to delete this ad?")) {
      await deleteSubscriber(postId);
      toast("subscription Deleted", "SUCCESS");
      await loadSubscribers();
    } else {
      toast("Error in delete subscription", "ERROR");
    }
  };

  return (
    <Main>
      <PageContainer
        title="Subscription"
        buttonText={loading ? "Loading..." : "ADD"}
        onButtonClick={() => {
          setSelectedSubscription(null);
          setViewMode(false);
          setShowModal(true);
        }}
      >
        <Modal
          visible={showModal}
          size="lg"
          onClose={() => {
            setShowModal(false);
            setSelectedSubscription(null);
            setViewMode(false);
          }}
          headerText={
            viewMode
              ? "View Subscription"
              : selectedSubscription
              ? "Edit Subscription"
              : "Add Subscription"
          }
          centered
        >
          <SubscriptionForm
            initialData={selectedSubscription}
            readOnly={viewMode}
            onSave={handleSave}
          />

          {viewMode && (
            <div className="d-flex justify-content-end mt-3">
              <button
                className="btn btn-success"
                onClick={() => setViewMode(false)}
              >
                Edit
              </button>
            </div>
          )}
        </Modal>

        <CollapseCard title="Subscription List">
          <SubscriptionList
            Subscription={Subscription}
            onEdit={handleEdit}
            onDelete={handleDelete}
            onView={handleView}
          />
        </CollapseCard>
      </PageContainer>
    </Main>
  );
};

export default Subscription;
